/*
 *
 * ProductDetailsPage actions
 *
 */

import { action, createAsyncAction } from 'typesafe-actions';

import ActionTypes from './constants';
import { FeedbackProductInput } from 'types/schema';

export const defaultAction = () => action(ActionTypes.DEFAULT_ACTION);
export const product = createAsyncAction(
  ActionTypes.FETCH_PRODUCT_REQUEST,
  ActionTypes.FETCH_PRODUCT_SUCCESS,
  ActionTypes.FETCH_PRODUCT_FAILURE,
)<void, {}, Error>();
export const relateProducts = createAsyncAction(
  ActionTypes.FETCH_RELATE_PRODUCTS_REQUEST,
  ActionTypes.FETCH_RELATE_PRODUCTS_SUCCESS,
  ActionTypes.FETCH_RELATE_PRODUCTS_FAILURE,
)<void, {}, Error>();

export const productItemsInProductGroups = createAsyncAction(
  ActionTypes.FETCH_PRODUCT_ITEMS_IN_PRODUCT_GROUPS_REQUEST,
  ActionTypes.FETCH_PRODUCT_ITEMS_IN_PRODUCT_GROUPS_SUCCESS,
  ActionTypes.FETCH_PRODUCT_ITEMS_IN_PRODUCT_GROUPS_FAILURE,
)<void, {}, Error>();

export const productItemsInProductFamily = createAsyncAction(
  ActionTypes.FETCH_PRODUCT_ITEMS_IN_PRODUCT_FAMILY_REQUEST,
  ActionTypes.FETCH_PRODUCT_ITEMS_IN_PRODUCT_FAMILY_SUCCESS,
  ActionTypes.FETCH_PRODUCT_ITEMS_IN_PRODUCT_FAMILY_FAILURE,
)<void, {}, Error>();

export const setVouchersForProduct = (data: any) => action(ActionTypes.SET_VOUCHERS_FOR_PRODUCT, data);

export const productReviews = createAsyncAction(
  ActionTypes.FETCH_PRODUCT_REVIEWS_REQUEST,
  ActionTypes.FETCH_PRODUCT_REVIEWS_SUCCESS,
  ActionTypes.FETCH_PRODUCT_REVIEWS_FAILURE,
)<{}, {}, Error>();

export const checkCanReviewProduct = (data: { callback: (canReview: boolean) => void }) =>
  action(ActionTypes.CHECK_CAN_REVIEW_PRODUCT, data);

export const submitReviewProduct = (data: { callback: (success: boolean) => void; input: FeedbackProductInput }) =>
  action(ActionTypes.SUBMIT_REVIEW_PRODUCT, data);
